export const apiServerConfig = {
  apiURL: process.env.REACT_APP_SERVER_IP_ADDRESS,
  cdnHost: process.env.REACT_APP_CDN_HOST,
}